<template>
    <Component
        :is="componentInstance"
        v-bind="$attrs"
        :get-data-vuex="getCities"
        :placeholder="placeholder"
        :multiple="multiple"
        :seed="JSON.stringify(filterOptions)"
        :value="value"
        class="white"
        field="name"
        @[event]="$emit(event, $event)">
    </Component>
</template>
<script>
  import { UsersSelect } from "@core/mixins/select/usersSelect";

  export default {
    name: "CitiesSelect",
    mixins: [UsersSelect],

    props: {
      routeParam: {
        type: String,
        default: "id"
      },

      namespaceModule: {
        type: String,
        default: "citiesFilters"
      }
    },

    methods: {
      async getCities (label = "", isLoading = false) {
        await this.getFiltersByName(this.namespaceModule, this.list, this.$route.query[this.routeParam] ?? this.value,
                                    this.routeParam, label, isLoading, this.filterOptions);
        return this.list;
      }
    }
  };
</script>

<style scoped>

</style>